import { useState } from 'react';
import { Link } from 'react-router-dom';
import { websites } from '@/mocks/websites';
import { categories } from '@/mocks/categories';

export default function Hero() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const filteredWebsites = searchTerm.trim()
    ? websites.filter(
        (w) =>
          w.name.includes(searchTerm) ||
          w.description.includes(searchTerm) ||
          w.tags.some((t) => t.includes(searchTerm))
      ).slice(0, 5)
    : [];

  const popularSites = websites.filter((w) => w.category === 'popular').slice(0, 6);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20Korean%20webtoon%20style%20illustration%20with%20soft%20warm%20gradient%20background%2C%20abstract%20comic%20panel%20patterns%20in%20gentle%20rose%20and%20gold%20tones%2C%20dreamy%20atmospheric%20light%2C%20minimalist%20design%20with%20flowing%20lines%20and%20subtle%20texture%2C%20no%20text%20no%20characters%20clean%20abstract%20composition&width=1600&height=900&seq=hero-bg-001&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50" />

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          韩漫导航
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-3 max-w-2xl mx-auto">
          汇集韩漫网站、韩漫网、韩漫之家与韩漫屋等热门平台入口
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
          提供免费韩漫漫画网址导航与在线观看汇总，方便漫迷集中浏览与收藏
        </p>

        <div className="max-w-lg mx-auto relative mb-10">
          <div className="flex items-center bg-white/95 backdrop-blur rounded-xl overflow-hidden">
            <div className="pl-4 pr-2">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowSuggestions(true);
              }}
              onFocus={() => setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              placeholder="搜索韩漫平台名称..."
              className="flex-1 py-3.5 pr-4 text-sm text-foreground-900 bg-transparent outline-none placeholder:text-foreground-400"
            />
          </div>

          {showSuggestions && searchTerm.trim() && filteredWebsites.length > 0 && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl overflow-hidden text-left z-20">
              {filteredWebsites.map((site) => (
                <a
                  key={site.id}
                  href={site.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-3 px-4 py-3 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className="ri-external-link-line text-primary-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{site.name}</div>
                    <div className="text-xs text-foreground-500">{site.tags.join(' · ')}</div>
                  </div>
                </a>
              ))}
            </div>
          )}

          {showSuggestions && searchTerm.trim() && filteredWebsites.length === 0 && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl p-4 text-center text-sm text-foreground-500 z-20">
              未找到匹配的韩漫平台
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2">
          {popularSites.map((site) => (
            <a
              key={site.id}
              href={site.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-4 py-2 bg-white/15 hover:bg-white/25 backdrop-blur text-white text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {site.name}
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {categories.filter((c) => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 backdrop-blur text-white/80 hover:text-white text-xs rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-xs`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}